export default {
    "required": "Enter",
    "filled": "Enter",
    "notEmpty": "The {label} cannot be empty",
    "empty": "The {label} must be empty",
    "minLength": "Insufficient character limit",
    "maxLength": "Character limit exceeded",
    "rangeLength": "The {label} length must be between {0} and {1}",
    "min": "The {label} must be {0} or more",
    "max": "The {label} must be {0} or less",
    "range": "The {label} must be between {0} and {1}",
    "pattern": "The {label} format is invalid",
    "is": "The {label} must be {0}",
    "isNot": "The {label} cannot be {0}",
    "equals": "The {label} must equal {0}",
    "notEquals": "The {label} cannot equal {0}",
    "confirmed": "The password entered twice is inconsistent",
    "includes": "The {label} must include {args}",
    "excludes": "The {label} cannot include {args}",
    "included": "The {label} must be a value of {args}",
    "excluded": "The {label} cannot be a value of {args}",
    "unique": "The {label} already exists",
    "noDuplicates": "Cannot contain duplicated items",
    "string": "Must be a string",
    "number": "Must be a number",
    "numeric": "Must be a number",
    "integer": "Must be an integer",
    "decimal": "Must be a valid decimal",
    "boolean": "Must be a boolean",
    "function": "Must be a function",
    "object": "Must be an object",
    "plainObject": "Must be a plain object",
    "array": "Must be an array",
    "alpha": "May only contain alphabetic characters",
    "alphaNum": "May only contain alpha-numeric characters",
    "alphaDash": "May only contain letters or '_'",
    "alphaNumDash": "May only contain a letter, number of '_'",
    "alphaSpaces": "May only contain letters or blank spaces",
    "lowerCase": "Uppercase letters are forbidden",
    "upperCase": "lowercase letters are forbidden",
    "^az": "Must start with a lowercase letter",
    "^az09": "Must start with a lowercase letter or number",
    "^az09_": "Must start with a lowercase letter, number or '_'",
    "^azAZ": "Must start with a letter",
    "^azAZ09": "Must start with a letter or number",
    "^azAZ09_": "Must start with a letter, number or '_'",
    "az09$": "Must end with a lowercase letter or number",
    "azAZ09$": "Must end with a letter or number",
    "^09$": "May only contain numbers",
    "^az09$": "May only contain lowercase letters or numbers",
    "^az09-$": "May only contain lowercase letters, numbers or '-'",
    "^az09-.$": "May only contain lowercase letters, numbers, '-' or '.'",
    "^azAZ09$": "May only contain letters or numbers",
    "^azAZ09-$": "May only contain letters, numbers or '-'",
    "^azAZ09_$": "May only contain letters, numbers or '_'",
    "^azAZ09-_$": "May only contain letters, numbers, '-' or '_'",
    "without--": "Two consecutive '-' is forbidden",
    "without__": "Two consecutive '_' is forbidden",
    "email": "Must be a valid email",
    "ip": "Must be a valid IP",
    "ipRange": "Must be a valid IP range",
    "port": "Must be a valid port",
    "url": "Must be a valid URL",
    "macAddress": "Must be a valid MAC address",
    "md5": "Must be a valid MD5",
    "ascii": "Must be a ASCII code",
    "base32": "Must be a base32 code",
    "base64": "Must be a base64 code",
    "byteLength": "Byte length is out of range",
    "dataURI": "Must be a valid dataURI code",
    "magnetURI": "Must be a valid magnetURI code",
    "divisibleBy": "Must be divisible by {0}",
    "fullWidth": "Must be full-width chars",
    "halfWidth": "Must be half-width chars",
    "hash": "Hash code is inconsistent with algorithm {0}",
    "hexColor": "Must be a hexadecimal color code",
    "hex": "Must be a hexadecimal number",
    "identityCard": "Must be a valid identity card number",
    "creditCard": "Must be a valid credit card number",
    "fqdn": "Must be a valid FQDN",
    "ipOrFQDN": "Must be an IP or FQDN",
    "isbn": "Must be a valid ISBN",
    "issn": "Must be a valid ISSN",
    "isin": "Must be a valid ISIN",
    "iso8601": "Must be in ISO8601 date format",
    "rfc3339": "Must be in RFC3339 date format",
    "iso31661Alpha2": "Must be an ISO 3166-1 Alpha-2 official assigned country code",
    "iso31661Alpha3": "Must be an ISO 3166-1 Alpha-3 official assigned country code",
    "json": "Must be a JSON format string",
    "jwt": "Must be a valid JSON Web Token",
    "latLong": "Must be a valid lat-long coordinate, e.g. (-17.738223, 85.605469)",
    "mobile": "Please input numbers only",
    "mongoId": "Must be a valid hex-encoded representation of a MongoDB ObjectId",
    "postalCode": "Must be a valid postal code",
    "uuid": "Must be a valid UUID",
    "chinese": "Must be Chinese"
};
//# sourceMappingURL=en-US.js.map